var map = {
	"./daily_bonus.png": 5637,
	"./order1_1.png": 7217,
	"./order2_1.png": 8542,
	"./order2_2.png": 4293,
	"./order3_1.png": 8719,
	"./order3_2.png": 6260,
	"./order3_3.png": 7389,
	"./regular1.png": 8113,
	"./regular2.png": 7946,
	"./regular3.png": 9171,
	"./regular4.png": 9004,
	"./regular5.png": 8101,
	"./regular6.png": 7102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2177;